var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('BaseInventory',{attrs:{"categoryId":"13","categoryName":"Stator","categorySectionIcon":"fa-wrench"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }